import clsx from 'clsx';
import styles from './styles.module.scss';

type HeaderProps = {
  text: string;
  className?: string;
};

const Header: React.FC<HeaderProps> = (props) => {
  const { text, className } = props;

  return <p className={clsx(styles.header, className)}>{text}</p>;
};

export default Header;
